import styled from 'styled-components';

export const StyledOnePaymentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;

    .inner-payments-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px; 
        margin-right: 100px;

    }

    .close-btn {
        height: 20px;
        font-weight: 300;
        font-size: 36px;
        line-height: .5;
        color: var(--bllink-blue);
        cursor: pointer;
    }
`